import SupplierApi from '../api/scm/supplier'
import CustomerApi from '../api/scm/customer'
const IndexComponent = () => import('../pages/index/index.vue')
// view routers

export default [
  // static view routers
  {
    path: '/info',
    name: 'user-info',
    meta: { isAuth: true, keepAlive: true },
    component: IndexComponent,
    children: [
      {
        path: '',
        name: '个人信息',
        component: () => import(/* webpackChunkName: "info" */ '../views/info/index.vue')
      }
    ]
  },
  {
    path: '/admin/basic-data/product-recycle',
    name: 'product-recycle',
    meta: { isAuth: true, keepAlive: true },
    component: IndexComponent,
    children: [
      {
        path: '',
        name: '产品回收站',
        component: () =>
          import(
            /* webpackChunkName: "product" */ '../views/admin/basic-data/product/product-recycle.vue'
          )
      }
    ]
  },
  {
    path: '/scm/customer',
    name: 'customer',
    component: IndexComponent,
    redirect: '/scm/customer/index',
    children: [
      {
        path: 'index',
        component: () =>
          import(/* webpackChunkName: "customer" */ '../views/scm/customer/index.vue'),
        name: '客户管理',
        props: { type: '客户', api: new CustomerApi() }
      }
    ]
  },
  {
    path: '/scm/supplier',
    name: 'supplier',
    component: IndexComponent,
    redirect: '/scm/supplier/index',
    children: [
      {
        path: 'index',
        component: () =>
          import(/* webpackChunkName: "customer" */ '../views/scm/customer/index.vue'),
        name: '供应商管理',
        props: { type: '供应商', api: new SupplierApi() }
      }
    ]
  },
  {
    path: '/notice/index',
    name: 'notice',
    meta: { isAuth: true, keepAlive: false },
    component: IndexComponent,
    children: [
      {
        path: '',
        name: '消息中心',
        component: () =>
          import(/* webpackChunkName: "notice" */ '../views/synergy/notice/index.vue')
      }
    ]
  },
  {
    path: '/notice',
    redirect: '/notice/index'
  },
  {
    path: '/my-package/index',
    name: 'my-package',
    meta: { isAuth: true, keepAlive: false },
    component: IndexComponent,
    children: [
      {
        path: '',
        name: '升级续费',
        component: () =>
          import(/* webpackChunkName: "my-package" */ '../views/my-package/index.vue')
      }
    ]
  },
  {
    path: '/invoicing/sale',
    component: IndexComponent,
    children: [
      {
        path: 'index/:id',
        component: () =>
          import(
            /* webpackChunkName: "invoicing-sale" */ '@/views/invoicing/sale/drawer/add-sale.vue'
          )
      }
    ]
  },
  {
    path: '/invoicing/sale/rent',
    name: 'rent',
    meta: { isAuth: true, keepAlive: false },
    component: IndexComponent,
    children: [
      {
        path: 'index/:id',
        component: () =>
          import(
            /* webpackChunkName: "rent" */ '../views/invoicing/sale/rent/components/rent-detail.vue'
          )
      }
    ]
  },
  {
    path: '/partner/illustration',
    redirect: '/partner/illustration/index',
    component: IndexComponent,
    children: [
      {
        path: 'index',
        component: () =>
          import(/* webpackChunkName: "rent" */ '../pages/partner-illustration/index.vue')
      }
    ]
  }
]
